import { render } from "./AvailWeek.vue?vue&type=template&id=6527c911&scoped=true"
import script from "./AvailWeek.vue?vue&type=script&lang=js"
export * from "./AvailWeek.vue?vue&type=script&lang=js"

import "./AvailWeek.vue?vue&type=style&index=0&id=6527c911&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6527c911"]])

export default __exports__